/**
 * Created by luka on 23.02.2018.
 */
import {post} from '../utils/api';
import {
	LEVEL_SET,
	LEVEL_UPDATED,
	UPDATE_TO_SAME_LEVEL,
} from '../utils/constants';
import {
	navigationToInfo,
	resetNavigationToOverview,
	navigationToMilestone, navigationToFeedback,
} from '../navigation/NavigationActions';
import {
	FEEDBACK_FETCH_DATA_SUCCESS,
	FEEDBACK_LOADING,
	LOADING_FEEDBACK_FAILED,
} from '../actions/types';
import {saveUser} from '../utils/auth';
import {userLoggedIn} from '../login/LoginAction';
import {milestoneTypes} from '../milestone/MilestoneScreen';

export function loadingFeedbackFailed(error) {
	return {
		type: LOADING_FEEDBACK_FAILED,
		error,
	};
}

export function feedbackLoading(bool) {
	return {
		type: FEEDBACK_LOADING,
		isLoading: bool,
	};
}

export function feddbackFetchDataSuccess(login) {
	return {
		type: FEEDBACK_FETCH_DATA_SUCCESS,
		login,
	};
}

export function feedbackFetchData(feedback, dayPosition) {
	return (dispatch) => {
		dispatch(feedbackLoading(true));

		post('setfeedback', {
			feedback: feedback,
		})
			.then((setFeedbackResponse) => {
				if (
					setFeedbackResponse.msg === LEVEL_SET ||
					setFeedbackResponse.msg === LEVEL_UPDATED ||
					setFeedbackResponse.msg === UPDATE_TO_SAME_LEVEL
				) {
					saveUser(setFeedbackResponse.user);

					dispatch(userLoggedIn(setFeedbackResponse.user)); //notify system that user object has changed
					dispatch(
						feddbackFetchDataSuccess(setFeedbackResponse.user)
					);
					if (!!dayPosition) {
						const {month, day} = milestoneTypes;
						if(dayPosition === '2'){
							dispatch(navigationToFeedback());
						}else {
							dispatch(
								navigationToMilestone({
									type: dayPosition === '30' ? month : day,
								})
							);
						}
					} else {
						dispatch(resetNavigationToOverview());
					}

					/*if (setFeedbackResponse.msg === LEVEL_SET) {
						//TODO navigate to success
						dispatch(navigationToInfo());
					}*/
				}
				dispatch(feedbackLoading(false));
			})
			.catch((error) => {
				dispatch(loadingFeedbackFailed(error));
				dispatch(feedbackLoading(false));
			});
	};
}



// WEBPACK FOOTER //
// ./src/rating/FeedbackAction.js